















import Component, { mixins } from "vue-class-component";
import { VModel } from "vue-property-decorator";
import { AxiosResponse } from "axios";
import Form from "@/general/abstract/form/mixin/Form";
import { MeterFormModel } from "@/context/meter/model/form/MeterFormModel";
import MeterRouter from "@/context/meter/router/MeterRouter";
import MeterForm from "@/context/meter/component/form/MeterForm.vue";
import FormBase from "@/general/abstract/form/FormBase.vue";
import { meterApi } from "@/context/meter/api/MeterApi";
import { IdResponse } from "@/common/model/IdResponse";

@Component({
  components: {
    FormBase,
    MeterForm
  }
})
export default class MeterUpdateForm extends mixins<
  Form<MeterFormModel, MeterFormModel, IdResponse>
>(Form) {
  @VModel({ default: new MeterFormModel() }) model!: MeterFormModel;

  buildCmd(): MeterFormModel {
    return this.model;
  }

  async submitApi(cmd: MeterFormModel): Promise<IdResponse> {
    const result: IdResponse = await meterApi.update<MeterFormModel, IdResponse>(cmd);
    return result;
  }

  showRoute(id: number): Record<string, unknown> {
    return new MeterRouter().show(id);
  }
}
